import { ReactNode } from 'react';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { ApolloProviderWrapper } from './ApolloProviderWrapper';
import { I18nProviderWrapper, I18nConfig } from './I18nProviderWrapper';
import { DynamicRemoteOverwrite } from './DynamicRemoteOverwrite';

interface GetProviderVariantProps {
  children: ReactNode;
}
export interface GlobalProviderProps extends GetProviderVariantProps {
  apolloClient?: ApolloClient<NormalizedCacheObject>;
  i18nConfig: I18nConfig;
}

export function GlobalProvider({
  apolloClient,
  i18nConfig,
  children,
}: GlobalProviderProps) {
  return (
    <ApolloProviderWrapper client={apolloClient}>
      <DynamicRemoteOverwrite>
        <I18nProviderWrapper config={i18nConfig}>
          {children}
        </I18nProviderWrapper>
      </DynamicRemoteOverwrite>
    </ApolloProviderWrapper>
  );
}
